const concepts = [
  "Object-Oriented Programming (OOP)",
  "Data Structures and Algorithms",
  "Distributed Systems",
  "RESTful API Design",
  "Multithreading",
  "Networking",
  "Operating Systems",
  "Machine Learning Fundamentals",
  "Software Project Management",
  "Software Testing and Quality Assurance",
  "Computer Vision",
  "Data Engineering"
];

export default concepts;